export default __webpack_public_path__ + "static/media/frank-hettmann.a2a923f7.png";